import IconProps from './icon';

const IconSearch = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.93797 0.980774C8.5179 0.980774 10.0331 1.6084 11.1503 2.72558C12.2675 3.84276 12.8951 5.35798 12.8951 6.93791C12.8951 8.41344 12.3544 9.76984 11.4654 10.8146L11.7128 11.0621H12.4369L17.0193 15.6445L15.6446 17.0192L11.0621 12.4368V11.7128L10.8147 11.4653C9.7699 12.3543 8.41351 12.895 6.93797 12.895C5.35804 12.895 3.84282 12.2674 2.72564 11.1502C1.60846 10.0331 0.980835 8.51784 0.980835 6.93791C0.980835 5.35798 1.60846 3.84276 2.72564 2.72558C3.84282 1.6084 5.35804 0.980774 6.93797 0.980774ZM6.93797 2.81374C4.64676 2.81374 2.8138 4.6467 2.8138 6.93791C2.8138 9.22911 4.64676 11.0621 6.93797 11.0621C9.22917 11.0621 11.0621 9.22911 11.0621 6.93791C11.0621 4.6467 9.22917 2.81374 6.93797 2.81374Z"
        fill={props.color}
      />
    </svg>
  );
};

export default IconSearch;
